<template>
    <div class="user-info d-flex">
        <div class="info-content d-flex">
            <div class="avatar">
                <img
                    v-if="userCenteredInfo"
                    :src="userCenteredInfo.avatar"
                    alt="avatar"
                />
            </div>
            <div class="personal" v-if="userCenteredInfo">
                <h2 class="user-name">
                    {{ userCenteredInfo.name || userCenteredInfo.username }}
                </h2>
                <span class="collections-info">
                    {{ userCenteredInfo.fav_count }} {{ $TL.favoriteNum }}
                </span>
                <span class="collections-info"
                    >{{ userCenteredInfo.m_count }} {{ $TL.zPictures }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
    name: "user-info",
    data() {
        return {
            favoriteNum: 31,
            pictureNum: 180
        };
    },
    computed: {
        ...mapState("global", []),
        ...mapState("userCentered", ["userCenteredInfo"])
    },
    created() {},
    methods: {}
};
</script>

<style lang="scss">
.user-info {
    justify-content: center;
    margin-top: 18px;

    .info-content {
        align-items: center;
        .avatar {
            flex-shrink: 0;
            width: 120px;
            height: 120px;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 24px;
            background-color: rgba(0, 0, 0, 0.03);

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }

    .personal {
        .user-name {
            font-size: 28px;
            margin-bottom: 8px;
        }

        .collections-info {
            font-size: 14px;
            margin-bottom: 4px;
            color: #3c4043;
            display: block;
        }
    }
}
</style>
